import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Experience from './components/Experience/Experience';
import Activities from './components/Activities/Activities';
import Skills from './components/Skills/Skills';
import Education from './components/Education/Education';
import Languages from './components/Language/Language';
import ExampleSection from './components/Example/ExampleSection';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
       <ExampleSection />
        <Projects />
         <Education />
         <Languages />
        <Experience />
        <Activities/>
        <Skills/>
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
